import React, { useEffect, useState } from 'react';
import { getReporterUsers } from '../utils/storage';
import './Modal.css';
import './AssignReporterModal.css';

// Picks a single reporter- or operator-role user to assign to an inspection
// (operator on execution day, then the reporter). The parent
// persists the choice (onAssign) and closes the modal.
export default function AssignReporterModal({ inspectionLabel, currentEmail, onCancel, onAssign }) {
  const [users, setUsers] = useState(null);   // null = loading
  const [selected, setSelected] = useState(currentEmail || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    getReporterUsers().then((list) => { if (!cancelled) setUsers(list); });
    return () => { cancelled = true; };
  }, []);

  async function handleOk() {
    const user = (users || []).find((u) => u.email === selected);
    if (!user) { setError('Select a reporter or operator to assign.'); return; }
    setSaving(true);
    setError('');
    try {
      await onAssign(user);   // parent persists + closes on success
    } catch (e) {
      setError(e?.message || 'Failed to assign.');
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={() => !saving && onCancel()}>
      <div className="modal assign-reporter-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Assign reporter / operator</h2>
        {inspectionLabel && <p className="modal-body-text assign-reporter-sub">{inspectionLabel}</p>}

        <div className="assign-reporter-list">
          {users === null ? (
            <div className="assign-reporter-empty">Loading…</div>
          ) : users.length === 0 ? (
            <div className="assign-reporter-empty">No reporter- or operator-role users found.</div>
          ) : (
            users.map((u) => (
              <label key={u.email} className={`assign-reporter-item${selected === u.email ? ' selected' : ''}`}>
                <input
                  type="radio"
                  name="assign-reporter"
                  checked={selected === u.email}
                  onChange={() => setSelected(u.email)}
                />
                <span className="assign-reporter-text">
                  <span className="assign-reporter-name">
                    {u.name}
                    {(u.roles || []).map((r) => (
                      <span key={r} className="assign-reporter-role">{r === 'operator' ? 'Operator' : 'Reporter'}</span>
                    ))}
                  </span>
                  <span className="assign-reporter-email">{u.email}</span>
                </span>
              </label>
            ))
          )}
        </div>

        {error && <div className="assign-reporter-error">{error}</div>}

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel} disabled={saving}>Cancel</button>
          <button className="btn btn-primary" onClick={handleOk} disabled={saving || !selected}>
            {saving ? 'Assigning…' : 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
}
